import { gql } from "@apollo/client";

export const CREATE_PRODUCT = gql`
  mutation CreateProductManual(
    $args: ProductCreateInput!
    $omitItems: Boolean
  ) {
    createProductManual(args: $args, omitItems: $omitItems) {
      id
      orderId
      productType
      teeth
      itemPreferences
      hasIndividualItemCaracteristics
      createdAt
      implantItem {
        id
        itemType
        teeth
        itemMaterial {
          id
          label
        }
        itemShade {
          id
          label
        }
        itemBilling {
          firstMaterialLotNumber
          firstMaterialTraceabilityId
          secondMaterialLotNumber
          id
        }
        abutmentMaterial {
          id
          label
        }
        abutmentType
        implantPlatform
        implantReference {
          brand
          label
          id
          platforms
        }
        retentionType
        scanBodySuggestion
        standardAbutmentSuggestion
        implantReferenceSuggestion
        teethshadeType
        multiShadeInfo {
          id
          teethShadeSide
          itemShade {
            id
            label
            shadeType
          }
        }
      }
      anatomyItem {
        id
        itemType
        teeth
        itemShade {
          id
          label
        }
        itemMaterial {
          id
          label
        }
        inlayCoreHasClavette
        inlayCoreScanPost
        inlayCoreMaterial {
          id
          label
        }
        itemBilling {
          firstMaterialLotNumber
          secondMaterialLotNumber
          firstMaterialTraceabilityId
          id
        }
        teethshadeType
        multiShadeInfo {
          teethShadeSide
          itemShade {
            id
            shadeType
            label
          }
        }
      }
      removableItem {
        id
        itemType
        teeth
        teethToManufacture
        workflowType
        dentistNotes
        isReplacement
        waxUpType
        fullDentureOrderType
        partialDentureOrderType
        imprintType
        rdvNumber
        rdv2Choice
        returnMethod
        itemMaterial {
          id
          label
        }
        teethShade {
          id
          label
        }
        gingivaShade {
          id
          label
        }
        itemBilling {
          firstMaterialLotNumber
          firstMaterialTraceabilityId
          secondMaterialLotNumber
          id
        }
        partialDenture {
          id
          missingTeeth
          hooks {
            id
            hooksMaterial {
              id
              label
            }
            hooksPosition
          }
          palatalMetalBand
          metalMesh
          lingualMetalBand
          customTray
        }
      }
    }
  }
`;

export const DELETE_MANY_PRODUCTS = gql`
  mutation DeleteManyProduct($where: ProductWhereInput) {
    deleteManyProduct(where: $where)
  }
`;

export const UPDATE_PRODUCT = gql`
  mutation UpdateProduct(
    $data: ProductUpdateInput!
    $where: ProductWhereUniqueInput!
  ) {
    updateProduct(data: $data, where: $where) {
      id
      orderId
      productType
      teeth
      itemPreferences
      hasIndividualItemCaracteristics
      createdAt
      implantItem {
        id
        itemType
        teeth
        itemMaterial {
          id
          label
        }
        itemShade {
          id
          label
        }
        itemBilling {
          firstMaterialLotNumber
          firstMaterialTraceabilityId
          secondMaterialLotNumber
          id
        }
        abutmentMaterial {
          id
          label
        }
        abutmentType
        implantPlatform
        implantReference {
          brand
          label
          id
          platforms
        }
        retentionType
        scanBodySuggestion
        standardAbutmentSuggestion
        implantReferenceSuggestion
        teethshadeType
        multiShadeInfo {
          id
          teethShadeSide
          itemShade {
            id
            label
            shadeType
          }
        }
      }
      anatomyItem {
        id
        itemType
        teeth
        itemShade {
          id
          label
        }
        itemMaterial {
          id
          label
        }
        inlayCoreHasClavette
        inlayCoreScanPost
        inlayCoreMaterial {
          id
          label
        }
        itemBilling {
          firstMaterialLotNumber
          secondMaterialLotNumber
          firstMaterialTraceabilityId
          id
        }
        teethshadeType
        multiShadeInfo {
          teethShadeSide
          itemShade {
            id
            shadeType
            label
          }
        }
      }
      removableItem {
        id
        itemType
        teeth
        teethToManufacture
        workflowType
        dentistNotes
        isReplacement
        waxUpType
        fullDentureOrderType
        partialDentureOrderType
        imprintType
        rdvNumber
        rdv2Choice
        returnMethod
        itemMaterial {
          id
          label
        }
        teethShade {
          id
          label
        }
        gingivaShade {
          id
          label
        }
        itemBilling {
          firstMaterialLotNumber
          firstMaterialTraceabilityId
          secondMaterialLotNumber
          id
        }
        partialDenture {
          id
          missingTeeth
          hooks {
            id
            hooksMaterial {
              id
              label
            }
            hooksPosition
          }
          palatalMetalBand
          metalMesh
          lingualMetalBand
          customTray
        }
      }
    }
  }
`;

export const UPDATE_ALL_ITEM_TEETH_OF_PRODUCTS = gql`
  mutation UpdateAllItemTeethOfProduct($productId: String!, $teeth: String!) {
    updateAllItemTeethOfProduct(productId: $productId, teeth: $teeth)
  }
`;
